import { Component, OnInit } from '@angular/core';
import { environment } from '@environment/environment';
import { AuthService } from '@impesa/ngx-core';
import { GlobalVarsService } from '@shared/services/global-vars/global-vars.service';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss'],
})
export class LogoutComponent implements OnInit {
  constructor(
    private readonly authService: AuthService,
    private readonly globals: GlobalVarsService
  ) {}

  ngOnInit() {
    this.globals.deleteCookie();
    this.authService.logout();
    const country = this.getCountry();
    localStorage.clear();
    this.gotoRedirectUrl(country);
  }

  getCountry() {
    return localStorage.getItem('country')?.toLowerCase().slice(0, 2) ?? '';
  }

  gotoRedirectUrl(country: string) {
    const url = environment.landingUrl;
    window.location.href = url.replace('{{country}}', country);
  }
}
